import { computed } from "vue";
export function useFiltering(allInstances) {
    const activeInstances = computed(() => {
        return allInstances.value.filter((item) => !item.hidden);
    });
    return {
        activeInstances,
    };
}
